const BACKGROUND = "BACKGROUND";
const CONTACT = "CONTACT";
const PROJECTS = "PROJECTS";
export default {
  PAGES: [BACKGROUND, PROJECTS, CONTACT],
  BACKGROUND,
  CONTACT,
  PROJECTS,
};
